var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "box expandable-box no-shadow has-border p-1" },
    [
      _c(
        "div",
        {
          staticClass: "box-header is-align-items-center",
          on: { click: _vm.toggle },
        },
        [
          _c("div", { staticClass: "columns is-fullwidth" }, [
            _c("div", { staticClass: "column is-half" }, [
              _c("span", { staticClass: "icon" }, [
                _c("i", {
                  class: _vm.isExpanded
                    ? "mdi mdi-chevron-down"
                    : "mdi mdi-chevron-right",
                }),
              ]),
              _c("span", { staticClass: "has-text-weight-bold" }, [
                _vm._v(_vm._s(_vm.isExpanded ? _vm.expendedTitle : _vm.title)),
              ]),
            ]),
            _c(
              "div",
              {
                staticClass: "column is-half",
                class: {
                  "is-flex is-justify-content-space-between": _vm.enableSort,
                },
              },
              [
                _c("span", {}, [
                  _vm._v(
                    _vm._s(_vm.isExpanded ? _vm.expendedSubTitle : _vm.subTitle)
                  ),
                ]),
                _vm.enableSort
                  ? _c(
                      "span",
                      {
                        ref: "dragHandleMounted",
                        staticClass: "item-drag-handle",
                      },
                      [
                        _c("span", { staticClass: "msr msr-24px" }, [
                          _vm._v("drag_indicator"),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
          ]),
        ]
      ),
      _c("transition", { attrs: { name: "expand" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isExpanded,
                expression: "isExpanded",
              },
            ],
            staticClass: "content",
            style: _vm.expandedStyle,
          },
          [_vm._t("default")],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }